<ng-container *transloco="let t">
    <section
        fxFlex="100"
        fxFlex.xs="100"
        fxFlex.sm="100"
        fxLayout="column"
        fxLayoutAlign="space-between"
        fxFlexFill
    >
        <h1>{{ t("auth.login.header") }}</h1>

        <form [formGroup]="formGroup" (ngSubmit)="emailOrPhoneSubmitted()">
            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.login.emailOrPhone") }}</mat-label>
                <input
                    matInput
                    formControlName="emailOrPhone"
                    maxlength="200"
                    cdkFocusInitial
                />
                <mat-error *ngIf="emailOrPhone?.hasError('required')">
                    {{ t("auth.account-setup.emailOrPhoneRequired") }}
                </mat-error>
                <mat-error
                    *ngIf="emailOrPhone?.hasError('invalidEmailOrPhoneNumber')"
                >
                    {{ t("auth.account-setup.invalidEmailOrPhoneNumber") }}
                </mat-error>
            </mat-form-field>

            <app-busyable-button
                [disabled]="formGroup.invalid"
                [busy]="busy"
                [text]="t('shared.continue') | uppercase"
            ></app-busyable-button>
        </form>
    </section>
</ng-container>
